import getAuth0 from './client';
import constants from '../../constants';

export default async function auth0Login(
  targetUrl,
  connection = constants.AUTH0_CONFIG.connection || null
) {
  const auth0 = await getAuth0();

  const baseUrl = encodeURIComponent(window.location.origin);

  await auth0.loginWithRedirect({
    appState: { targetUrl },
    theme: 'nitro',
    baseUrl,
    ...(connection && { connection })
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth0/login.js